import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csforloop(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# for loop tutorial For Beginners</title>
 <meta name="description" content="C# for loop tutorial for beginners.for loop in C# is The body of the loop must be executed until the given condition is false. CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# for loop,c# for loop for,c sharp for loop,c# for loop for loop,end for loop c#,c# exit for loop,exit while loop c#,c# continue,for loop foreach c#,c# foreach for loop,c# foreach continue" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-for-loop" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">CSharp(C#) for Loop</h1>
    <div className="first">
        <a href="/csharp-do-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-break">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">For loop in CSharp
</h2>
<p className="mt-4 para">1, The body of the loop must be executed until the given condition is false<br/>
2, In the c# for loop semicolon, must be used <br/>
3, This c# for loop is used to repeat a particular piece of code for a fixed no of times<br/>

</p>


<h2 className='headings'>for loop syntax in c#</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}{"\n"}
            <span className="qwerty-7">For </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-6">initialization</span>
            <span className="qwerty-3">;</span> 
            <span className="qwerty-5"> condition</span>
            <span className="qwerty-3">;</span> 
            <span className="qwerty-4"> iteration</span>
            <span className="qwerty-3">)</span> 
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-10">Statement </span>
            <span className="qwerty">sequence</span> 
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2">C# for loop example:</h2>


<h2 className='headings'>Q-Write a Program to print a number from 1 to 10 in C# for loop?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-6">namespace </span>
            <span className="qwerty">forloop</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty">Program </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">int </span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">for </span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-10">1</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-3">&#60; </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-10">10</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-1">++</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">Loop </span>
              <span className="qwerty-6">Start: </span>
            <span className="qwerty-3">" </span>
            <span className="qwerty-1">+ </span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}{"\n"}
              <span className="qwerty-4">Loop </span>
              <span className="qwerty-6">Start: </span>
              <span className="qwerty-10">1 </span>
              {"\n"}
              <span className="qwerty-4">Loop </span>
              <span className="qwerty-6">Start: </span>
              <span className="qwerty-10">2 </span>
              {"\n"}
              <span className="qwerty-4">Loop </span>
              <span className="qwerty-6">Start: </span>
              <span className="qwerty-10">3 </span>
              {"\n"}
              <span className="qwerty-4">Loop </span>
              <span className="qwerty-6">Start: </span>
              <span className="qwerty-10">4 </span>
              {"\n"}
              <span className="qwerty-4">Loop </span>
              <span className="qwerty-6">Start: </span>
              <span className="qwerty-10">5 </span>
              {"\n"}
              <span className="qwerty-4">Loop </span>
              <span className="qwerty-6">Start: </span>
              <span className="qwerty-10">6 </span>
              {"\n"}
              <span className="qwerty-4">Loop </span>
              <span className="qwerty-6">Start: </span>
              <span className="qwerty-10">7 </span>
              {"\n"}
              <span className="qwerty-4">Loop </span>
              <span className="qwerty-6">Start: </span>
              <span className="qwerty-10">8 </span>
              {"\n"}
              <span className="qwerty-4">Loop </span>
              <span className="qwerty-6">Start: </span>
              <span className="qwerty-10">9 </span>
              {"\n"}
              <span className="qwerty-4">Loop </span>
              <span className="qwerty-6">Start: </span>
              <span className="qwerty-10">10 </span>
              {"\n"} {"\n"}</code></pre>
        </div>
      </div>



<h2 className='headings'>Q-Write a program loop starts from 1 to 10 but print from 2 to 10 in C# for loop Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-6">namespace </span>
            <span className="qwerty">forloop</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty">Program </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">int </span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">for </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-10">1</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-3"> &#60; </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-10">10</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">i</span>
            <span className="qwerty-1">++</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}{"\n"}
              <span className="qwerty-10">2 </span>
              {"\n"}
              <span className="qwerty-10">3 </span>
              {"\n"}
              <span className="qwerty-10">4 </span>
              {"\n"}
              <span className="qwerty-10">5 </span>
              {"\n"}
              <span className="qwerty-10">6 </span>
              {"\n"}
              <span className="qwerty-10">7 </span>
              {"\n"}
              <span className="qwerty-10">8 </span>
              {"\n"}
              <span className="qwerty-10">9 </span>
              {"\n"}
              <span className="qwerty-10">10 </span>
              {"\n"}
              <span className="qwerty-10">11</span>
              {"\n"} {"\n"}</code></pre>
        </div>
      </div>



<h2 className='headings'>Q-Write a program to print a name when the program is complete in c# for loop Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-6">namespace </span>
            <span className="qwerty">forloop</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty">Program </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">int </span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">for </span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-10">1</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-3">&#60; </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-10">10</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-1">++</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">Code </span>
            <span className="qwerty-6">Exampler</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}{"\n"}
              <span className="qwerty-10">1 </span>
              {"\n"}
              <span className="qwerty-10">2 </span>
              {"\n"}
              <span className="qwerty-10">3 </span>
              {"\n"}
              <span className="qwerty-10">4 </span>
              {"\n"}
              <span className="qwerty-10">5 </span>
              {"\n"}
              <span className="qwerty-10">6 </span>
              {"\n"}
              <span className="qwerty-10">7 </span>
              {"\n"}
              <span className="qwerty-10">8 </span>
              {"\n"}
              <span className="qwerty-10">9 </span>
              {"\n"}
              <span className="qwerty-10">10 </span>
              {"\n"}
              <span className="qwerty-4">Code </span>
              <span className="qwerty-6">Exampler</span>
              {"\n"} {"\n"}</code></pre>
        </div>
      </div>


<h2 className='headings'>Q-Write a program to print a name again in c# for loop Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-6">namespace </span>
            <span className="qwerty">forloop</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty">Program </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">int </span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">for </span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-10">1</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-3">&#60; </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-10">10</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-1">++</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-4">Ram </span>
            <span className="qwerty-6">Ram</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}{"\n"}
              <span className="qwerty-10">1 </span>
              {"\n"}
              <span className="qwerty-4">Ram </span>
              <span className="qwerty-6">Ram</span>
              {"\n"}
              <span className="qwerty-10">2 </span>
              {"\n"}
              <span className="qwerty-4">Ram </span>
              <span className="qwerty-6">Ram</span>
              {"\n"}
              <span className="qwerty-10">3 </span>
              {"\n"}
              <span className="qwerty-4">Ram </span>
              <span className="qwerty-6">Ram</span>
              {"\n"}
              <span className="qwerty-10">4 </span>
              {"\n"}
              <span className="qwerty-4">Ram </span>
              <span className="qwerty-6">Ram</span>
              {"\n"}
              <span className="qwerty-10">5 </span>
              {"\n"}
              <span className="qwerty-4">Ram </span>
              <span className="qwerty-6">Ram</span>
              {"\n"}
              <span className="qwerty-10">6 </span>
              {"\n"}
              <span className="qwerty-4">Ram </span>
              <span className="qwerty-6">Ram</span>
              {"\n"}
              <span className="qwerty-10">7 </span>
              {"\n"}
              <span className="qwerty-4">Ram </span>
              <span className="qwerty-6">Ram</span>
              {"\n"}
              <span className="qwerty-10">8 </span>
              {"\n"}
              <span className="qwerty-4">Ram </span>
              <span className="qwerty-6">Ram</span>
              {"\n"}
              <span className="qwerty-10">9 </span>
              {"\n"}
              <span className="qwerty-4">Ram </span>
              <span className="qwerty-6">Ram</span>
              {"\n"}
              <span className="qwerty-10">10 </span>
              {"\n"}
              <span className="qwerty-4">Ram </span>
              <span className="qwerty-6">Ram</span>
              {"\n"} {"\n"}</code></pre>
        </div>
      </div>



<h2 className='headings'>Q-Write a program to combine a no and name in c# for loop Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-6">namespace </span>
            <span className="qwerty">forloop</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty">Program </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">int </span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">for </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-10">1</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-3">&#60; </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-10">10</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-1">++</span>
            <span className="qwerty-7">) </span>
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">Hello </span>
              <span className="qwerty-4">Ram </span>
            <span className="qwerty-6">"</span>
            <span className="qwerty-3">+</span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}{"\n"}
              <span className="qwerty-10">Hello </span>
              <span className="qwerty-4">Ram </span>
              <span className="qwerty-6">1</span>
              {"\n"}
              <span className="qwerty-10">Hello </span>
              <span className="qwerty-4">Ram </span>
              <span className="qwerty-6">2</span>
              {"\n"}
              <span className="qwerty-10">Hello </span>
              <span className="qwerty-4">Ram </span>
              <span className="qwerty-6">3</span>
              {"\n"}
              <span className="qwerty-10">Hello </span>
              <span className="qwerty-4">Ram </span>
              <span className="qwerty-6">4</span>
              {"\n"}
              <span className="qwerty-10">Hello </span>
              <span className="qwerty-4">Ram </span>
              <span className="qwerty-6">5</span>
              {"\n"}
              <span className="qwerty-10">Hello </span>
              <span className="qwerty-4">Ram </span>
              <span className="qwerty-6">6</span>
              {"\n"}
              <span className="qwerty-10">Hello </span>
              <span className="qwerty-4">Ram </span>
              <span className="qwerty-6">7</span>
              {"\n"}
              <span className="qwerty-10">Hello </span>
              <span className="qwerty-4">Ram </span>
              <span className="qwerty-6">8</span>
              {"\n"}
              <span className="qwerty-10">Hello </span>
              <span className="qwerty-4">Ram </span>
              <span className="qwerty-6">9</span>
              {"\n"}
              <span className="qwerty-10">Hello </span>
              <span className="qwerty-4">Ram </span>
              <span className="qwerty-6">10</span>
              {"\n"} {"\n"}</code></pre>
        </div>
      </div>



<h2 className='headings'>Q-Write a program to fibonacci series in c# for loop Example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-6">namespace </span>
            <span className="qwerty">forloop</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-2">class </span>
            <span className="qwerty">Program </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">static </span>
            <span className="qwerty-2">void</span>
            <span className="qwerty-3"> Main </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-3">string</span>
            <span className="qwerty-7">[]</span>
            <span className="qwerty-2">args</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-7">int </span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-6">0</span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">b</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-6">1</span>
            <span className="qwerty-3">,</span>
            <span className="qwerty-4">c</span>
            <span className="qwerty-3">,</span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6">for </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-6">1</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-3">&#60; </span>
            <span className="qwerty-1">= </span>
            <span className="qwerty-6">10</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-1">++</span>
            <span className="qwerty-7">) </span>
            {"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}
            <span className="qwerty-4">c </span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-3"> + </span>
            <span className="qwerty-4">b</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-5">Console.</span>
            <span className="qwerty-3">WriteLine</span>
            <span className="qwerty-7"> (</span>
            <span className="qwerty-4">c</span>
            <span className="qwerty-7">)</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-4">a</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-4">b</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-4">b</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-4">c</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code>
              {"\n"}{"\n"}
              <span className="qwerty-6">1</span>
              {"\n"}
              <span className="qwerty-6">2</span>
              {"\n"}
              <span className="qwerty-6">3</span>
              {"\n"}
              <span className="qwerty-6">5</span>
              {"\n"}
              <span className="qwerty-6">8</span>
              {"\n"}
              <span className="qwerty-6">13</span>
              {"\n"}
              <span className="qwerty-6">21</span>
              {"\n"}
              <span className="qwerty-6">34</span>
              {"\n"}
              <span className="qwerty-6">55</span>
              {"\n"}
              <span className="qwerty-6">89</span>
              {"\n"} {"\n"}</code></pre>
        </div>
      </div>


  <h1 className="mt-5">  </h1>
    
  <div className="back">
        <a href="/csharp-do-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-break">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csforloop;